var __TEMP__ = require('./_basePickBy.js');var basePickBy = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./hasIn.js');var hasIn = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn(object, path);
  });
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = basePick;
